import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  styled,
} from '@mui/material';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  content: string;
};

const StyledPre = styled('pre')({
  fontSize: '18px',
  border: '2px solid grey',
  borderRadius: '5px',
  padding: '14px',

  /* Fixed line height */
  lineHeight: '22px',
  /* Use linear-gradient for background image */
  backgroundImage: 'linear-gradient(180deg, #eee 50%, #fff 50%)',
  /* Size background so that the height is 2x line-height */
  backgroundSize: '100% 44px',
  /* Offset the background along the y-axis by top padding */
  backgroundPosition: '0 14px',

  /* Line numbers */
  counterReset: 'line-numbering',
  'span:before': {
    content: 'counter(line-numbering)',
    counterIncrement: 'line-numbering',
    paddingRight: '1em',

    textAlign: 'right',
    opacity: 0.5,
  },
});

export const PrettyPrintPopup: React.FC<Props> = ({
  isOpen,
  onClose,
  content,
}) => {
  // Splits content into lines, to add line numbers
  const lines = content.split('\n');

  const addLineNumbers = lines.length > 1;

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      scroll={'body'}
      aria-labelledby="pretty-print-modal-title"
      aria-describedby="pretty-print-modal-description">
      <DialogContent>
        <StyledPre>
          {addLineNumbers
            ? lines.map((l, i) => (
                <span key={i}>
                  {l}
                  <br />
                </span>
              ))
            : content}
        </StyledPre>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Lukk</Button>
      </DialogActions>
    </Dialog>
  );
};
